import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";
import { RootState } from "src/store";
import { logout } from "src/store/slices/auth";

export default function SessionExpiredWrapper() {
  const isTokenExpired = useSelector((state: RootState) => state.auth.isTokenExpired);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleGoToLogin = () => {
    dispatch(logout());
  };

  return (
    <>
      <Outlet />
      <Modal open={isTokenExpired} closable={false} mask={{closable:false, blur:true}} keyboard={false} footer={null} centered>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <h2 className="text-xl font-semibold text-font-active">{t("SessionExpired.title")}</h2>
            <p className="text-sm text-font-subtle">{t("SessionExpired.message")}</p>
          </div>
          <Link
            to="/login"
            replace
            onClick={handleGoToLogin}
            className="bg-background-primary text-font-inverted flex w-full items-center justify-center rounded-md p-3 font-semibold"
          >
            {t("SessionExpired.goToLogin")}
          </Link>
        </div>
      </Modal>
    </>
  );
}
